import React from 'react';

/** Labelled text field in mobile's Input style: white, rounded, hairline border. */
export const AuthField: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & { label: string; error?: string | null }
> = ({ label, error, id, ...props }) => {
  const fieldId = id ?? `field-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={fieldId} className="font-body text-[0.8125rem] font-medium text-on-surface-variant">
        {label}
      </label>
      <input
        id={fieldId}
        {...props}
        aria-invalid={error ? true : undefined}
        className={`w-full rounded-xl border border-solid bg-surface-container-lowest px-4 py-3 font-body text-[0.9375rem] text-on-surface outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-on-surface-variant focus:border-accent focus:shadow-[0_0_0_3px_var(--focus-ring)] ${
          error ? 'border-error' : 'border-outline-variant'
        }`}
      />
      {error && (
        <p role="alert" className="m-0 font-body text-xs text-error">
          {error}
        </p>
      )}
    </div>
  );
};

/** Centered single-column shell for the auth pages, on warm paper. */
export const AuthShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex min-h-[100dvh] justify-center bg-surface px-5 pb-10 pt-[calc(2.5rem+env(safe-area-inset-top,0px))] md:items-center md:pt-10">
    <div className="w-full max-w-[26rem]">{children}</div>
  </div>
);
